<template>
  <div class="station-report">

    <!-- START Search Box -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card shadow">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-3 col-lg-4">
                <b-form-group class="ct-mb-margin-bottom-100" label-class="col-form-label"
                              label="조회 월" label-for="searchMonth"
                              label-cols="3" content-cols="9">
                  <date-picker id="searchMonth" v-model="searchForm.month"
                               type="month" value-type="YYYY-MM" append-to-body lang="ko"
                               :disabled-date="disabledAfterToday" @input="search" />
                </b-form-group>
              </div>
              <div class="col-xl-3 col-lg-4">
                <b-form-group class="ct-mb-margin-bottom-100" label-class="col-form-label"
                              label="충전소 유형" label-for="searchStationType"
                              label-cols="3" label-cols-lg="4">
                  <multiselect id="searchStationType"
                               v-model="searchForm.stationType" :options="stationTypeOptions"
                               label="text" placeholder="" select-label=""
                               :allow-empty="false" deselect-label=""
                               @input="getStationItems()">
                    <span slot="noResult">No Result</span>
                  </multiselect>
                </b-form-group>
              </div>
              <div class="col-xl-3 col-lg-4">
                <b-form-group label-class="col-form-label"
                              label="충전소" label-for="searchStation"
                              label-cols="3" content-cols="9">
                  <multiselect id="searchStation"
                               v-model="searchForm.station" :options="stationOptions"
                               label="text" placeholder="" select-label=""
                               :allow-empty="false" deselect-label="" @input="search">
                    <span slot="noResult">No Result</span>
                  </multiselect>
                </b-form-group>
              </div>
<!--              <search-buttons layout-class="col-lg-3 ct-margin-top-25"-->
<!--                              resetBtnClass="search-btn-reset" searchBtnClass="search-btn-search"-->
<!--                              :reset-fn="reset" :search-fn="search" />-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Search Box -->

    <!-- START Empty Template -->
    <template v-if="$_utils.isEmpty(result) || $_utils.isEmpty(result.info)">
      <div class="row">
        <div class="col-lg-12">
          <div class="card shadow">
            <div class="card-body">
              <div class="text-center ct-padding-top-100 ct-padding-bottom-100">
                <div class="row justify-content-center mt-5 mb-5">
                  <div class="col-sm-5">
                    <img src="@/assets/images/widget-img.png" class="img-fluid mx-auto d-block" />
                  </div>
                </div>
                <h4 class="text-uppercase mt-5 mb-5">
                  <span class="text-danger">충전소</span>를 선택하여, 데이터를 조회 하세요.
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- END Empty Template -->

    <!-- START Report Template -->
    <template v-else>
      <div class="row">
        <div class="col-lg-12">
          <div class="card shadow">
            <div class="card-body pb-0">

              <!-- START Report Title -->
              <div class="row mt-2 mb-2">
                <div class="col-lg-4">
                  <h4 class="text-deep-green ct-padding-left-50">
                    <span class="font-size-16 icon-padding-right">
                      <i class="mdi mdi-office-building-outline" />
                    </span>
                    {{ result.info.placeName }}
                  </h4>
                </div>
                <div class="col-lg-8">
                  <div class="text-align-end">
                    <ul class="list-inline main-chart mb-0">
                      <li class="list-inline-item chart-border-left me-0 mb-2" :class="{'border-0':i === 0}"
                          v-for="(item, i) in reportInfo">
                        <h5>
                          <span class="font-size-13 icon-padding-right" :class="`text-${item.iconColor}`">
                            <i :class="`mdi ${item.icon}`" />
                          </span>
                          <span class="text-muted d-inline-block fw-normal font-size-14">{{ item.label }}</span>
                          <span class="main-value ms-3">{{ item.mainValue }}</span>
                          <span v-if="!$_utils.isEmpty(item.subValue)" class="sub-value ct-padding-left-50">
                            {{ item.subValue }}
                          </span>
                        </h5>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- END Report Title -->

              <hr class="separator separator--dotter" />

              <div class="row">
                <!-- START Left Zone -->
                <div class="col-lg-6">
                  <div class="card border-0">
                    <!-- START Info Box -->
                    <div class="row">
                      <div class="col-lg-4">
                        <small-info-count-to card-bg=""
                                             icon-image="mdi-account-multiple-check" icon-color="success"
                                             title="이용" value-title="건"
                                             :compared="!$_utils.isEmpty(result.info) ? result.info.usedCountVariation : 0"
                                             :end-val="!$_utils.isEmpty(result.info) ? result.info.usedCount : 0" />
                      </div>
                      <div class="col-lg-4">
                        <small-info-count-to card-bg=""
                                             icon-image="mdi-battery-charging-high" icon-color="primary"
                                             title="충전량" value-title="kWh"
                                             :compared="!$_utils.isEmpty(result.info) ? result.info.totEnergyVariation : 0"
                                             :end-val="!$_utils.isEmpty(result.info) ? result.info.totEnergy : 0" />
                      </div>
                      <div class="col-lg-4">
                        <small-info-count-to card-bg=""
                                             icon-image="mdi-cash-multiple" icon-color="danger"
                                             title="충전 금액" value-title="원"
                                             :compared="!$_utils.isEmpty(result.info) ? result.info.totCostVariation : 0"
                                             :end-val="!$_utils.isEmpty(result.info) ? result.info.totCost : 0" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4">
                        <small-info-count-to card-bg=""
                                             icon-image="mdi-lightning-bolt" icon-color="primary"
                                             title="완속 이용률" value-title="%"
                                             :compared="!$_utils.isEmpty(result.info) ? result.info.utilSlowVariation : 0"
                                             :end-val="!$_utils.isEmpty(result.info) ? result.info.utilRateSlow : 0" />
                      </div>
                      <div class="col-lg-4">
                        <small-info-count-to card-bg=""
                                             icon-image="mdi-lightning-bolt" icon-color="danger"
                                             title="급속 이용률" value-title="%"
                                             :compared="!$_utils.isEmpty(result.info) ? result.info.utilFastVariation : 0"
                                             :end-val="!$_utils.isEmpty(result.info) ? result.info.utilRateFast : 0" />
                      </div>
                      <div class="col-lg-4">
                        <small-info-count-to card-bg=""
                                             icon-image="mdi-gas-station-off" icon-color="secondary"
                                             title="고장" value-title="건"
                                             :compared="!$_utils.isEmpty(result.info) ? result.info.faultCountVariation : 0"
                                             :end-val="!$_utils.isEmpty(result.info) ? result.info.faultCount : 0" />
                      </div>
                    </div>
                    <!-- END Info Box -->

                    <!-- START List By Evse -->
                    <div class="row mt-3 mb-3">
                      <div class="col-lg-12">
                        <card-title icon-image="mdi-ev-station" title="충전기별 이용 현황" text-color="title" />
                        <div class="evse-use-table">
                          <b-table class="datatables text-nowrap"
                                   :fields="evseFields" :items="!$_utils.isEmpty(result.evseUsedStats) ? result.evseUsedStats : null">
                            <template #cell(chargeUserCount)="data">
                              {{ $_utils.comma(data.item.chargeUserCount) }}
                            </template>
                            <template #cell(chargeCount)="data">
                              {{ $_utils.comma(data.item.chargeCount) }}
                            </template>
                            <template #cell(chargeEnergy)="data">
                              {{ $_utils.comma(data.item.chargeEnergy) }}
                            </template>
                            <template #cell(chargeCost)="data">
                              {{ $_utils.comma(data.item.chargeCost) }}
                            </template>
                            <template #cell(faultCount)="data">
                              {{ $_utils.comma(data.item.faultCount) }}
                            </template>
                          </b-table>
                        </div>
                      </div>
                    </div>
                    <!-- END List By Evse -->

                    <!-- START List By User -->
                    <div class="row mt-3">
                      <div class="col-lg-12">
                        <card-title icon-image="mdi-account-group" title="이용자별 이용 현황" text-color="title" />
                        <div class="row">
                          <div class="col-lg-4 mb-3">
                            <info-mini-box box-bg="light"
                                           title-bg="primary-gradient" :title-width="40" title="회원"
                                           value-color="black" :value-width="60"
                                           :value="`${result.userTypeCount.memberCount}명`"
                                           :sub-value="` ( ${result.userTypeCount.memberChargeCount}건 )`" />
                          </div>
                          <div class="col-lg-4 mb-3">
                            <info-mini-box box-bg="light"
                                           title-bg="primary-gradient" :title-width="40" title="비회원"
                                           value-color="black" :value-width="60"
                                           :value="`${result.userTypeCount.nonmemberCount}명`"
                                           :sub-value="` ( ${result.userTypeCount.nonmemberChargeCount}건 )`" />
                          </div>
                          <div class="col-lg-4 mb-3">
                            <info-mini-box box-bg="light"
                                           title-bg="primary-gradient" :title-width="40" title="로밍"
                                           value-color="black" :value-width="60"
                                           :value="`${result.userTypeCount.roamingCount}명`"
                                           :sub-value="` ( ${result.userTypeCount.roamingChargeCount}건 )`" />
                          </div>
                        </div>
                        <div class="user-use-table">
                          <b-table class="datatables text-nowrap"
                                   :fields="userFields" :items="!$_utils.isEmpty(result.userStats) ? result.userStats : null">
                            <template #cell(chargeUserCount)="data">
                              {{ $_utils.comma(data.item.chargeUserCount) }}
                            </template>
                            <template #cell(chargeCount)="data">
                              {{ $_utils.comma(data.item.chargeCount) }}
                            </template>
                            <template #cell(chargeEnergy)="data">
                              {{ $_utils.comma(data.item.chargeEnergy) }}
                            </template>
                            <template #cell(chargeCost)="data">
                              {{ $_utils.comma(data.item.chargeCost) }}
                            </template>
                            <template #cell(faultCount)="data">
                              {{ $_utils.comma(data.item.faultCount) }}
                            </template>
                          </b-table>
                        </div>
                      </div>
                    </div>
                    <!-- END List By User -->
                  </div>
                </div>
                <!-- END Left Zone -->

                <!-- START Right Zone -->
                <div class="col-lg-6">
                  <div class="card card-height-100">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-lg-6 mt-2">
                          <card-title icon-image="mdi-chart-bar" title="이용률" text-color="title" />
                        </div>
                        <div class="col-lg-6">
                          <b-form-group class="ct-mb-margin-bottom-100" label-class="col-form-label"
                                        label="충전기 ID" label-for="searchEvse"
                                        label-cols="3" content-cols="9">
                            <multiselect id="searchEvse"
                                         v-model="searchForm.evse" :options="evseOptions"
                                         label="text" placeholder="" select-label=""
                                         :allow-empty="false" deselect-label=""
                                         @input="getChartItems()">
                              <span slot="noResult">No Result</span>
                            </multiselect>
                          </b-form-group>
                        </div>
                      </div>
                      <div id="chart-line" class="ct-chart-border mt-3">
                        <apexchart ref="srChart1" type="line" height="242"
                                   :options="srChartOptions1" :series="srChartOptions1.series" />
                      </div>
                      <div id="chart-line" class="ct-chart-border mt-3">
                        <apexchart ref="srChart2" type="bar" height="240"
                                   :options="srChartOptions2" :series="srChartOptions2.series" />
                      </div>
                      <div id="chart-line" class="ct-chart-border mt-3">
                        <apexchart ref="srChart3" type="line" height="242"
                                   :options="srChartOptions3" :series="srChartOptions3.series" />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END Right Zone -->
              </div>

            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- END Report Template -->

  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import smallInfoCountTo from '@/views/components/infoSmallCountTo.vue';
import cardTitle from '@/views/components/cardTitle.vue';
import infoMiniBox from '@/views/components/infoMiniBox.vue';
import SearchButtons from "@/views/components/searchButtons.vue";

export default {
  components: { SearchButtons, Multiselect, smallInfoCountTo, cardTitle, infoMiniBox },
  data() {
    return {
      searchForm: {
        month: moment().subtract(1,'months').format('YYYY-MM'),
        stationType: { 'value': 'all', 'text': '전체' },
        station: null,
        evse: { 'value': 'all', 'text': '전체' }
      },
      stationTypeOptions: [],
      stationOptions: [],
      result: null,
      reportInfo: [
        { label: '충전소 유형', icon: 'mdi-office-building-marker-outline', mainValue: '', subValue: '' },
        { label: '완속 충전기', icon: 'mdi-lightning-bolt', iconColor: 'primary', mainValue: '', subValue: '기' },
        { label: '급속 충전기', icon: 'mdi-lightning-bolt', iconColor: 'danger', mainValue: '', subValue: '기' },
        { label: '기간', icon: 'mdi-calendar-clock', mainValue: '', subValue: '' }
      ],
      evseFields: [
        { key: 'csoEvseNum', label: '충전기' },
        { key: 'evseCapacity', label: '용량' },
        { key: 'chargeUserCount', label: '이용자', sortable: true },
        { key: 'chargeCount', label: '이용', sortable: true },
        { key: 'chargeEnergy', label: '충전량', sortable: true },
        { key: 'chargeCost', label: '충전 금액', sortable: true },
        { key: 'faultCount', label: '고장', sortable: true }
      ],
      userFields: [],
      evseOptions: [],
      chartResult: null,
      srChartOptions1: {
        chart: {
          toolbar: { show: false }
        },
        colors: ['#0576b9', '#f56e50'],
        stroke: {
          curve: 'straight',
          width: 3
        },
        dataLabels: {
          enabled: false
        },
        title: {
          text: '시간별',
          align: 'left',
          style: {
            fontWeight: 'light',
            color:  '#035383'
          }
        },
        xaxis: {
          type: 'category',
          categories: [],
          labels: {
            formatter: function (value) {
              if (value === undefined) return '';
              if (typeof value !== 'string')  value = String(value);

              return value.substring(0, 2);
            }
          }
        },
        series: []
      },
      srChartOptions2: {
        chart: {
          toolbar: { show: false }
        },
        colors: ['#0576b9', '#f56e50'],
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 1,
          colors: ['transparent']
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '35%',
            endingShape: 'rounded'
          },
        },
        title: {
          text: '요일별',
          align: 'left',
          style: {
            fontWeight: 'light',
            color:  '#035383'
          }
        },
        xaxis: {
          type: 'category',
          categories: [],
          labels: {
            formatter: function (value) {
              if (value === undefined) return '';
              if (typeof value !== 'string')  value = String(value);

              return value + '요일';
            }
          }
        },
        series: []
      },
      srChartOptions3: {
        chart: {
          toolbar: { show: false }
        },
        colors: ['#0576b9', '#f56e50'],
        stroke: {
          curve: 'straight',
          width: 3
        },
        dataLabels: {
          enabled: false
        },
        title: {
          text: '일별',
          align: 'left',
          style: {
            fontWeight: 'light',
            color:  '#035383'
          }
        },
        xaxis: {
          type: 'category',
          categories: [],
          labels: {
            formatter: function (value) {
              if (value === undefined) return '';
              if (typeof value !== 'string')  value = String(value);

              return value.substring(8, 10);
            }
          }
        },
        series: []
      }
    }
  },
  mounted() {
    const vm = this;

    vm.getStationTypeItems();
    vm.getStationItems();
  },
  methods: {
    disabledAfterToday(date) {
      const today = new Date();

      return date > new Date(today.setMonth(today.getMonth()-1));
    },
    getStationTypeItems() {
      const vm = this;
      const _url = `/onmapi/stats/report/search/place-type`;

      this.$axios.get(_url).then((res) => {
        vm.stationTypeOptions = res.data.items.map(item => ({
          value: item.placeType,
          text: item.placeTypeName
        }));
        vm.stationTypeOptions.unshift({ 'value': 'all', 'text': '전체' });
      }).catch((error) => {
        //this.$swal('충전소 유형 데이터 조회 실패', '', 'error');
        console.error(error)
      });
    },
    getStationItems() {
      const vm = this;
      const _url = `/onmapi/stats/report/search/place`;

      vm.searchForm.station = null;

      this.$axios.get(_url, {
        params: {
          placeType: vm.searchForm.stationType.value
        }
      }).then((res) => {
        vm.stationOptions = res.data.items.map(item => ({
          value: item.placeId,
          text: item.placeName
        }));
      }).catch((error) => {
        //this.$swal('충전소 목록 데이터 조회 실패', '', 'error');
        console.error(error)
      });
    },
    // reset() {
    //   const vm = this;
    //   const today = new Date();
    //
    //   vm.searchForm = {
    //     /*month: new Date(today.setMonth(today.getMonth()-1)),*/
    //     month: new Date(moment('2023-05', 'YYYY-MM')),
    //     stationType: { 'value': 'all', 'text': '전체' },
    //     station: null,
    //     evse: { 'value': 'all', 'text': '전체' }
    //   }
    //
    //   vm.getStationItems();
    // },
    search() {
      const vm = this;

      if (this.$_utils.isEmpty(vm.searchForm.station)) {
        this.$swal('충전소를 선택하세요', '', 'warning');
        return false;
      }

      vm.getItems();
      vm.getEvseItems();
    },
    getItems() {
      const vm = this;
      const _url = `/onmapi/stats/report/place`;
      const excludeFields = ['userId', 'memberType', 'chargeCount', 'chargeEnergy', 'chargeCost'];

      vm.userFields = [
        { key: 'userId', label: '이용자 ID' },
        { key: 'memberType', label: '유형' },
        { key: 'chargeCount', label: '이용', sortable: true },
        { key: 'chargeEnergy', label: '충전량', sortable: true },
        { key: 'chargeCost', label: '충전 금액', sortable: true }
      ];

      this.$axios.get(_url, {
        params: {
          targetMonth: vm.searchForm.month,
          placeId: vm.searchForm.station.value
        }
      }).then((res) => {
        vm.result = Object.assign({}, res.data);

        Object.keys(vm.result.userStats[0]).forEach(item => {
          if (!excludeFields.includes(item)) {
            vm.userFields.push({ key: item, label: item, sortable: true });
          }
        });

        if (vm.result.info) {
          vm.reportInfo[0].mainValue = this.$_app.code.placeType[vm.result.info.placeType];
          vm.reportInfo[1].mainValue = vm.result.info.evseSlowCount;
          vm.reportInfo[2].mainValue = vm.result.info.evseFastCount;
          vm.reportInfo[3].mainValue = vm.result.info.dayPeriod;
        } else {
          throw new Error ('No reports for the selected period')
        }
      }).catch((err) => {
        this.$swal('조회 기간의 리포트가 존재하지 않습니다.', '', 'warning');
        console.error(err)
      })
    },
    getEvseItems() {
      const vm = this;
      const _url = `/onmapi/stats/report/util-rate/search`;

      vm.searchForm.evse = { 'value': 'all', 'text': '전체' };

      this.$axios.get(_url, {
        params: {
          targetMonth: vm.searchForm.month,
          placeId: vm.searchForm.station.value
        }
      }).then((res) => {
        vm.evseOptions = res.data.items.map(item => ({
          value: item.csoEvseNum,
          text: item.csoEvseNum
        }));
        vm.evseOptions.unshift({ 'value': 'all', 'text': '전체' });

        vm.getChartItems();
      }).catch((error) => {
        //this.$swal('충전기 목록 데이터 조회 실패', '', 'error');
        console.error(error)
      });
    },
    getChartItems() {
      const vm = this;
      const _url = `/onmapi/stats/report/util-rate/chart`;

      this.$axios.get(_url, {
        params: {
          targetMonth: vm.searchForm.month,
          placeId: vm.searchForm.station.value,
          csoEvseNum: vm.searchForm.evse.value
        }
      }).then((res) => {
        vm.chartResult = Object.assign({}, res.data);
        vm.drawChart();
      }).catch((error) => {
        //this.$swal('차트 데이터 조회 실패', '', 'error');
        console.error(error)
      });
    },
    drawChart() {
      const vm = this;

      // 시간별
      let categoriesByTime = [];
      let chartDataSlowByTime = [];
      let chartDataFastByTime = [];

      if (vm.result.info) {
        vm.chartResult.byTime.forEach(item => {
          categoriesByTime.push(item.statsHour);

          chartDataSlowByTime.push(item.utilRateSlow);
          chartDataFastByTime.push(item.utilRateFast);
        });

        vm.srChartOptions1.xaxis.categories = categoriesByTime;
        vm.srChartOptions1.series = [{
          name: '완속',
          data: chartDataSlowByTime
        },{
          name: '급속',
          data: chartDataFastByTime
        }];

        // 요일별
        /*let categoriesByDay = [];
        let chartDataSlowByDay = [];
        let chartDataFastByDay = [];

        vm.chartResult.byDay.forEach(item => {
          categoriesByDay.push(item.dayName);

          chartDataSlowByDay.push(item.utilRateSlow);
          chartDataFastByDay.push(item.utilRateFast);
        });*/

        const categoriesByDay = vm.chartResult.byDay.map(item => item.dayName);
        const chartDataSlowByDay = vm.chartResult.byDay.map(item => item.utilRateSlow);
        const chartDataFastByDay = vm.chartResult.byDay.map(item => item.utilRateFast);

        //vm.srChartOptions2.xaxis.categories = categoriesByDay;


        this.$refs.srChart2.updateOptions({
          xaxis: {
            categories: categoriesByDay
          }
        })

        vm.srChartOptions2.series = [{
          name: '완속',
          data: chartDataSlowByDay
        },{
          name: '급속',
          data: chartDataFastByDay
        }];

        // 일별
        let categoriesByDate = [];
        let chartDataSlowByDate = [];
        let chartDataFastByDate = [];

        vm.chartResult.byDate.forEach(item => {
          categoriesByDate.push(item.statDate);

          chartDataSlowByDate.push(item.utilRateSlow);
          chartDataFastByDate.push(item.utilRateFast);
        });

        //vm.srChartOptions3.xaxis.categories = categoriesByDate;

        this.$refs.srChart3.updateOptions({
          xaxis: {
            categories: categoriesByDate
          }
        })
        vm.srChartOptions3.series = [{
          name: '완속',
          data: chartDataSlowByDate
        },{
          name: '급속',
          data: chartDataFastByDate
        }];
      }


    }
  }
}
</script>
